








































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import CalibrationSelector from './calibration-selector.vue';
import ManageSelector from './manage-selector.vue';
import KmDocModal from '../components/Modals/km-doc-modal.vue';
import { approveCalibration, deleteQATask, getCalibrationTaskList, querySimilarKnowledge } from '@/api/ticket';

interface CalibrationItem {
    qaId: string;
    taskId: string;
    questionDesc: string;
    answer: string;
    ticketIdList: number[];
    createTime: string;
    category: string;
    labels: string[];
    archiveCategory: string;
    calibrationStatus: string;
    similarKnowledge?: {
        question: any;
        answer: any;
        qaId: string;
    };
    similarKmDoc?: {
        docName: any;
        url: string;
    };
    overrideSimilarKnowledge?: boolean;
}

@Component({
    components: {
        CalibrationSelector,
        ManageSelector,
        KmDocModal
    }
})
export default class CalibrationPage extends Vue {
    loading: boolean = false;
    calibrationList: CalibrationItem[] = [];
    calibrationTotal: number = 0;
    currentPage: number = 1;
    pageSize: number = 10;
    detailModalVisible: boolean = false;
    currentCalibration: CalibrationItem | null = null;
    currentFilter: any = {};
    scope?: any;
    showValidation: boolean = false;

    // 选择相关
    selectedCalibrationList: CalibrationItem[] = [];

    // 生成学城文档弹窗
    kmDocModalVisible: boolean = false;

    // 知识管理
    @Prop({ type: Boolean, default: false })
    isManageMode: boolean;

    @State(state => state.cti.env)
    env: string;

    get ticketBaseUrl() {
        return this.env === 'test'
            ? '//tt.cloud.test.sankuai.com/ticket/detail?id='
            : this.env === 'staging'
            ? '//tt.fetc.st.sankuai.com/ticket/detail?id='
            : '//tt.sankuai.com/ticket/detail?id=';
    }

    /**
     * 选中的知识 qaId 列表
     */
    get selectedQaIds() {
        return this.selectedCalibrationList.map(item => item.qaId);
    }

    created() {
        this.initCalibrationList();
    }

    buildQueryParams() {
        const archiveList = this.currentFilter.archiveIds?.map(sub => {
            if (sub && sub.id && Array.isArray(sub.id)) {
                return {
                    id: sub.id[sub.id.length - 1],
                    namePath: sub.namePath || ''
                };
            }
            return sub;
        });
        const params = {
            ...this.currentFilter,
            rgId: this.rgId,
            archives: archiveList || []
        };

        if (this.isManageMode) {
            params.calibrationStatus = 'PASSED';
            params.knowledgeCreatedAtStart = this.currentFilter.createdTimeRange?.[0] || '';
            params.knowledgeCreatedAtEnd = this.currentFilter.createdTimeRange?.[1] || '';
        } else {
            if (!this.currentFilter.calibrationStatus) {
                params.calibrationStatus = ['UNCALIBRATED', 'FAILED'];
            }
            params.taskCreatedAtStart = this.currentFilter.createdTimeRange?.[0] || '';
            params.taskCreatedAtEnd = this.currentFilter.createdTimeRange?.[1] || '';
        }

        return params;
    }

    /**
     * 获取校准列表
     */
    async fetchCalibrationList() {
        this.loading = true;
        try {
            const queryParams = this.buildQueryParams();
            const res = await getCalibrationTaskList(this.currentPage, this.pageSize, queryParams);
            if (res.code === 200) {
                this.calibrationList = res.data.items || [];
                this.calibrationTotal = res.data.tn || 0;
            }
        } catch (error) {
            console.error('获取校准列表失败:', error);
        } finally {
            this.loading = false;
        }
    }

    initCalibrationList() {
        const url = new URLSearchParams(window.location.search);
        const taskId = url.get('taskId');

        if (taskId) {
            this.currentFilter = {
                ...this.currentFilter,
                taskId
            };
        }

        this.$nextTick(() => {
            this.fetchCalibrationList();
        });
    }

    /**
     * 处理筛选条件变化
     */
    handleFilterChange(newFilter: any) {
        this.currentFilter = { ...this.currentFilter, ...newFilter };
        this.currentPage = 1;
        this.fetchCalibrationList();
    }

    /**
     * 处理校准提交成功
     */
    handleCalibrationSubmitted(taskData: any) {
        console.log('知识校准任务已提交:', taskData);
        this.currentPage = 1;
        this.fetchCalibrationList();
    }

    /**
     * 处理分页变化
     */
    handlePageChange() {
        this.fetchCalibrationList();
    }

    /**
     * 处理表格选择变化
     */
    handleSelectionChange(selection: CalibrationItem[]) {
        this.selectedCalibrationList = selection;
    }

    /**
     * 跨页选中匹配方法
     */
    indexOfSelection(row: CalibrationItem, selection: CalibrationItem[]) {
        return selection.map(s => s.qaId).indexOf(row.qaId);
    }

    /**
     * 打开生成学城文档弹窗
     */
    handleOpenKmDocModal() {
        if (this.selectedCalibrationList.length === 0) {
            this.$mtd.message({
                type: 'warning',
                message: '请先选择要生成文档的知识'
            });
            return;
        }
        this.kmDocModalVisible = true;
    }

    /**
     * 学城文档生成成功回调
     */
    handleKmDocSuccess() {
        // 清空选择
        this.selectedCalibrationList = [];
        // 清除表格选中状态
        const table: any = this.$refs.calibrationTable;
        if (table && table.clearSelection) {
            table.clearSelection();
        }
    }

    /**
     * 显示删除确认弹窗
     */
    handleDeleteConfirm(calibration: CalibrationItem) {
        console.log('calibration', calibration);
        this.$mtd.confirm({
            title: '确定删除？',
            showCancelButton: true,
            type: 'warning',
            okButtonText: '删除',
            message: `删除后不可恢复，请谨慎操作`,
            okButtonProps: {
                type: 'danger'
            },
            onOk: () => {
                return this.handleDelete(calibration.qaId);
            },
            onCancel: () => {
                console.log('取消删除');
            }
        });
    }

    /**
     * 执行删除操作
     */
    async handleDelete(qaId: string) {
        try {
            const res = await deleteQATask(qaId);
            if (res.code === 200) {
                this.$mtd.message({
                    type: 'success',
                    message: '已删除任务'
                });
                this.fetchCalibrationList();
            }
        } catch (error) {
            this.$mtd.message({
                type: 'error',
                message: '操作失败'
            });
        }
    }

    /**
     * 查看详情
     */
    async handleViewDetail(calibration: CalibrationItem) {
        this.currentCalibration = calibration;
        this.showValidation = false;

        try {
            const res = await querySimilarKnowledge(calibration.qaId);
            if (res.code === 200 && res.data) {
                this.currentCalibration = {
                    ...this.currentCalibration,
                    similarKnowledge: res.data.similarKnowledge,
                    similarKmDoc: res.data.similarKmDoc
                };
            }
        } catch (error) {
            console.log('查询相似知识失败:', error);
        }

        this.detailModalVisible = true;
    }

    /**
     * 处理详情模态框确认
     */
    handleDetailModalOk() {
        this.detailModalVisible = false;
        this.currentCalibration = null;
    }

    /**
     * 复制内容
     */
    handleCopyContent() {
        if (this.currentCalibration) {
            const content = `问题描述(Q): ${this.currentCalibration.questionDesc}\n\n问题答案(A): ${this.currentCalibration.answer}`;
            navigator.clipboard
                .writeText(content)
                .then(() => {
                    this.$mtd.message({
                        type: 'success',
                        message: '内容已复制到剪贴板'
                    });
                })
                .catch(() => {
                    this.$mtd.message({
                        type: 'error',
                        message: '复制失败'
                    });
                });
        }
    }

    /**
     * 取消操作
     */
    handleCancel() {
        this.detailModalVisible = false;
        this.currentCalibration = null;
    }

    /**
     * 拒绝校准详情
     */
    async handleRejectDetail() {
        if (this.currentCalibration) {
            if (!this.currentCalibration.questionDesc || !this.currentCalibration.answer) {
                this.showValidation = true;
                this.$mtd.message({
                    type: 'error',
                    message: '请填写完整的问题描述和答案'
                });
                return;
            }

            try {
                const params = {
                    qaId: this.currentCalibration.qaId,
                    docId: '',
                    calibrationStatus: 'FAILED',
                    questionDesc: this.currentCalibration.questionDesc,
                    answer: this.currentCalibration.answer
                };
                const res = await approveCalibration(params);
                if (res.code === 200) {
                    this.$mtd.message.error({
                        type: 'success',
                        message: '校准不通过'
                    });
                    this.detailModalVisible = false;
                    this.currentCalibration = null;
                    this.showValidation = false;
                    this.fetchCalibrationList();
                }
            } catch (error) {
                console.log('操作失败:', error);
            }
        }
    }

    /**
     * 通过并入库
     */
    async handleApprove() {
        if (this.currentCalibration) {
            if (!this.currentCalibration.questionDesc || !this.currentCalibration.answer) {
                this.showValidation = true;
                this.$mtd.message({
                    type: 'error',
                    message: '请填写完整的问题描述和答案'
                });
                return;
            }

            console.log('currentCalibration', this.currentCalibration);
            try {
                const params = {
                    qaId: this.currentCalibration.qaId,
                    calibrationStatus: 'PASSED',
                    questionDesc: this.currentCalibration.questionDesc,
                    answer: this.currentCalibration.answer,
                    overrideSimilarQaId: this.currentCalibration.overrideSimilarKnowledge ? this.currentCalibration.similarKnowledge?.qaId : null
                };

                const res = await approveCalibration(params);
                if (res.code === 200) {
                    this.$mtd.message({
                        type: 'success',
                        message: '已通过并入库'
                    });
                    this.detailModalVisible = false;
                    this.currentCalibration = null;
                    this.showValidation = false;

                    this.$nextTick(() => {
                        this.fetchCalibrationList();
                    });
                }
            } catch (error) {
                console.log('操作失败:', error);
            }
        }
    }

    /**
     * 获取校准状态标签
     */
    getCalibrationStatusLabel(status: string): string {
        const statusMap: { [key: string]: string } = {
            UNCALIBRATED: '未校准',
            PASSED: '已通过',
            FAILED: '不通过'
        };
        return statusMap[status] || status;
    }

    getCalibrationStatusType(status: string): string {
        const typeMap: { [key: string]: string } = {
            UNCALIBRATED: 'orange',
            PASSED: 'green',
            FAILED: 'red'
        };
        return typeMap[status] || 'info';
    }

    get modalTitle(): string {
        return this.isManageMode ? '知识管理' : '知识校准';
    }

    /**
     * 获取RG ID
     */
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
